import { ApiService } from "./apiService";
import { ListDto } from "../types/dto/ListDto";

export const STORE_ORDER_STATUSES = [
  'on_hold',
  'pending',
  'preparing',
  'ready_to_ship',
  'shipped',
  'in_delivery',
  'delivered',
  'delivery_failed',
  'cancelled',
  'partially_returned',
  'returned',
] as const;

export type StoreOrderStatus = typeof STORE_ORDER_STATUSES[number];

export interface StoreOrdersFilters {
  storeId?: string;
  status?: StoreOrderStatus | '';
  from?: string;
  to?: string;
}

export type ListStoreOrdersDto = ListDto & StoreOrdersFilters;

// Every store's part of every order. An empty filter is left off the request
// rather than sent blank, which the server would reject.
export const getStoreOrders = async ({ page, size, ...filters }: ListStoreOrdersDto) => {
  const params: Record<string, string | number> = { page, size };
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params[key] = value;
  });
  return await ApiService.get(`store-orders`, { params });
}
